import React, { useState, useMemo } from 'react'
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  TableContainer,
  Input,
  InputGroup,
  InputLeftElement,
  Flex,
  Badge,
} from '@chakra-ui/react'
import { useRoleta } from '../hooks/RoletaContext'
import { LinhaCliente } from './LinhaCliente'
import { FiSearch, FiRefreshCw } from 'react-icons/fi'
import { useDebounce } from '../../../../hooks/useDebounce'

export const TabelaClientes = () => {
  const { clientes = [], isLoading, error, isRefetching } = useRoleta()
  const [filtro, setFiltro] = useState('')
  const debouncedFiltro = useDebounce(filtro, 300) // 300ms de debounce

  const handleFiltro = (e) => {
    setFiltro(e.target.value)
  }

  const clientesFiltrados = useMemo(() => {
    if (!Array.isArray(clientes)) return []

    return clientes.filter(
      (cliente) =>
        cliente.nome_cliente?.toLowerCase().includes(debouncedFiltro.toLowerCase()) ||
        cliente.empresa_cliente?.toLowerCase().includes(debouncedFiltro.toLowerCase()) ||
        cliente.codigo_cliente?.toString().includes(debouncedFiltro) ||
        cliente.telefone_cliente?.includes(debouncedFiltro) ||
        cliente.email_cliente?.toLowerCase().includes(debouncedFiltro.toLowerCase())
    )
  }, [clientes, debouncedFiltro])

  if (isLoading) {
    return (
      <Box textAlign="center" py={10}>
        <Spinner size="xl" color="blue.500" />
        <Text mt={4}>Carregando clientes para sorteio...</Text>
      </Box>
    )
  }

  if (error) {
    return (
      <Alert status="error" borderRadius="md">
        <AlertIcon />
        <Text>Erro ao carregar os clientes. Por favor, tente novamente.</Text>
      </Alert>
    )
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <InputGroup flex="1" mr={4}>
          <InputLeftElement pointerEvents="none">
            <FiSearch color="gray.300" />
          </InputLeftElement>
          <Input placeholder="Buscar cliente por nome, empresa, código, telefone ou email" value={filtro} onChange={handleFiltro} />
        </InputGroup>

        {isRefetching && (
          <Badge display="flex" alignItems="center" colorScheme="blue" p={2} borderRadius="md">
            <Spinner size="sm" mr={2} />
            <Text fontSize="sm">Atualizando dados...</Text>
          </Badge>
        )}
      </Flex>

      <TableContainer>
        <Table variant="simple" size="md">
          <Thead>
            <Tr>
              <Th width="3%"></Th>
              <Th>Nome do Cliente</Th>
              <Th>Empresa</Th>
              <Th>Telefone</Th>
              <Th>Email</Th>
              <Th>Código do Sorteio</Th>
              <Th width="10%">Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {clientesFiltrados.length > 0 ? (
              clientesFiltrados.map((cliente, index) => <LinhaCliente key={`${cliente.codigo_cliente}-${index}`} cliente={cliente} />)
            ) : (
              <Tr>
                <td colSpan={7}>
                  <Text textAlign="center" py={4}>
                    Nenhum cliente encontrado
                  </Text>
                </td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
